import React from "react";
import { connect } from "react-redux";
import {
  postSiesteMulti,
  postSiesteSimple,
  updateSiesteEvent,
  deleteSiesteEvent,
} from "../les-tabs-ducks/Sieste.ducks";
import _ from "lodash";
import moment from "moment";
import Img from "react-image";
import srcIconCheck from "../../../../../../styles/img/icon-check-white.svg";
import srcIconClock from "../../../../../../styles/img/icon-sieste.svg";
import { withTranslation } from 'react-i18next';

moment.locale("fr");

function notEmpty(value) {
  return !_.isEmpty(value);
}

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;
const IconClock = () => <Img src={srcIconClock} className="img-fluid" />;

class Sieste extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      siesteFrom: "",
      siesteTo: "",
      duration: "",
      firstInit: true,
      startArray: [],
      endArray: [],
      initializeUpdate: false,
      opacity: { opacity: 0.25, pointerEvents: "none" },
    };
    this.handleStart = this.handleStart.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEventDelete = this.handleEventDelete.bind(this);
  }

  componentDidMount() {
    if (this.props.kidItem) {
      let kidItem = this.props.kidItem;
      let startArray = this.handleStart(kidItem);
      let endArray = this.handleEnd(kidItem);
      this.setState({ startArray: startArray, endArray: endArray });
    }
  }

  componentDidUpdate() {
    if (
      this.props.kidItem &&
      this.props.isUpdate &&
      !this.state.initializeUpdate &&
      notEmpty(this.props.siesteData)
    ) {
      let data = this.props.siesteData;
      let siesteFrom = `${moment(data.offsetDateTime).format("H")}h${moment(
        data.offsetDateTime
      ).format("mm")}`;
      let siesteTo = `${moment(data.offsetDateTimeFin).format("H")}h${moment(
        data.offsetDateTimeFin
      ).format("mm")}`;
      let duration = moment(siesteTo, "HH:mm").diff(
        moment(siesteFrom, "HH:mm")
      );
      let kidItem = this.props.kidItem;
      let startArray = this.handleStart(kidItem);
      let endArray = this.handleEnd(kidItem);
      this.setState({
        siesteFrom: siesteFrom,
        siesteTo: siesteTo,
        duration: `${moment.duration(duration).hours()}h${moment(
          duration
        ).format("mm")}`,
        initializeUpdate: true,
        opacity: { opacity: 0.25, pointerEvents: "none" },
        startArray: startArray,
        endArray: endArray,
      });
    } else if (
      this.props.kidItem &&
      this.props.onlyView &&
      !this.state.initializeUpdate &&
      notEmpty(this.props.siesteData)
    ) {
      let data = this.props.siesteData;
      let siesteFrom = `${moment(data.offsetDateTime).format("H")}h${moment(
        data.offsetDateTime
      ).format("mm")}`;
      let siesteTo = `${moment(data.offsetDateTimeFin).format("H")}h${moment(
        data.offsetDateTimeFin
      ).format("mm")}`;
      let duration = moment(siesteTo, "HH:mm").diff(
        moment(siesteFrom, "HH:mm")
      );

      this.setState({
        siesteFrom: siesteFrom,
        siesteTo: siesteTo,
        duration: `${moment.duration(duration).hours()}h${moment(
          duration
        ).format("mm")}`,
        initializeUpdate: true,
        opacity: { opacity: 0.25, pointerEvents: "none" },
        startArray: [siesteFrom],
        endArray: [siesteTo],
      });
    } else if (
      this.props.readySubmit === false &&
      notEmpty(this.state.siesteFrom) &&
      notEmpty(this.state.siesteTo)
    ) {
      this.props.handleReadySubmit();
    }
  }

  handleChange = (event) => {
    if (!this.props.onlyView) {
      let name = event.target.id;
      let duration;
      this.setState({ [name]: event.target.value }, () => {
        if (name === "siesteFrom") {
          let endArray = this.props.submitMulti
            ? this.handleEnd(this.props.dataMulti.lastArrived)
            : this.handleEnd(this.props.kidItem);
          this.setState(
            {
              endArray: endArray,
              siesteTo: "",
            },
            () => {
              if (
                notEmpty(this.state.siesteFrom) &&
                notEmpty(this.state.siesteTo)
              ) {
                duration = moment(this.state.siesteTo, "HH:mm").diff(
                  moment(this.state.siesteFrom, "HH:mm")
                );
                this.setState({
                  duration: `${moment.duration(duration).hours()}h${moment(
                    duration
                  ).format("mm")}`,
                });
              } else {
              }
            }
          );
        }
        if (notEmpty(this.state.siesteFrom) && notEmpty(this.state.siesteTo)) {
          duration = moment(this.state.siesteTo, "HH:mm").diff(
            moment(this.state.siesteFrom, "HH:mm")
          );
          this.setState({
            opacity: { opacity: 1 },
            duration: `${moment.duration(duration).hours()}h${moment(
              duration
            ).format("mm")}`,
          });
        } else {
          this.setState({ duration: `` });
        }
      });
    }
  };

  handleStart(kidItem) {
    console.log(this.props.kidItem)
    let i = 0;
    let array = [""];
    let nowTime = moment();
    let initTime =
      !this.props.submitMulti && !this.props.onlyView && !this.props.isUpdate
        ? moment(kidItem.agenda.statutDetails.dateTime).set({ minutes: 0 })
        : !this.props.submitMulti
        ? moment(nowTime).set({ hour: moment(kidItem.agenda.statutDetails.dateTime).format("h"), minute: moment(kidItem.agenda.statutDetails.dateTime).format("mm")})
        : moment(this.props.dataMulti.lastArrived).set({ minutes: 0 });
    let newTime = moment(initTime);
    let newerTime;
    if (notEmpty(kidItem) || this.props.submitMulti) {
      do {
        i = i + 1;
        newerTime = moment(newTime).add(15, "m");
        newTime = moment(newerTime);
        if (newerTime.isAfter(initTime)) {
          array = array.concat(
            `${moment(newerTime).format("H")}h${moment(newerTime).format("mm")}`
          );
        }
      } while (newerTime.isBetween(initTime, nowTime));
      return array;
    }
  }

  handleEnd(kidItem) {
    let i = 0;
    let array = [""];
    let hours;
    let minutes;
    let siesteFrom = this.state.siesteFrom;
    let hourAndMin = notEmpty(siesteFrom)
      ? ([hours, minutes] = siesteFrom.split("h"))
      : [];
    let nowTime = moment();
    let initTime =
      !this.props.submitMulti && _.isEmpty(siesteFrom)
        ? moment(kidItem.agenda.statutDetails.dateTime).set({ minutes: 0 })
        : notEmpty(siesteFrom)
        ? moment().set({ hour: parseInt(hours), minute: parseInt(minutes) })
        : moment(nowTime).set({ hour: 8, minute: 0 });
    let maxTime = moment(initTime).add(5, "h");
    let newTime = _.isEmpty(siesteFrom)
      ? moment(initTime).add(15, "m")
      : moment(initTime);
    let newerTime;
    if (notEmpty(kidItem) || this.props.submitMulti) {
      do {
        i = i + 1;
        newerTime = moment(newTime).add(15, "m");
        newTime = moment(newerTime);
        if (newerTime.isAfter(initTime)) {
          array = array.concat(
            `${moment(newerTime).format("H")}h${moment(newerTime).format("mm")}`
          );
        }
      } while (newerTime.isBetween(initTime, maxTime));
    }
    return array;
  }

  handleSubmit(event) {
    event.preventDefault();
    if (
      this.props.isUpdate &&
      notEmpty(this.state.siesteFrom) &&
      notEmpty(this.state.siesteTo)
    ) {
      let listIds = this.props.dataMulti.listChild;
      let { siesteFrom, siesteTo } = this.state;
      let [hourStart, minuteStart] = siesteFrom.split("h");
      let [hourEnd, minuteEnd] = siesteTo.split("h");
      let offsetDateTime = moment().set({
        hour: parseInt(hourStart),
        minute: parseInt(minuteStart),
        seconds: 0,
      });
      let offsetDateTimeFin = moment().set({
        hour: parseInt(hourEnd),
        minute: parseInt(minuteEnd),
        seconds: 0,
      });
      let data = {
        idsEnfants: listIds,
        offsetDateTime: moment(offsetDateTime).format(),
        offsetDateTimeFin: moment(offsetDateTimeFin).format(),
      };
      this.props.updateSiesteEvent(
        localStorage.getItem("token"),
        this.props.idEvent,
        data,
        this.props.kidItem.id
      );
    }
    if (
      this.props.submitMulti &&
      notEmpty(this.state.siesteFrom) &&
      notEmpty(this.state.siesteTo)
    ) {
      let listIds = this.props.dataMulti.listChild;
      let { siesteFrom, siesteTo } = this.state;
      let [hourStart, minuteStart] = siesteFrom.split("h");
      let [hourEnd, minuteEnd] = siesteTo.split("h");
      let offsetDateTime = moment().set({
        hour: parseInt(hourStart),
        minute: parseInt(minuteStart),
        seconds: 0,
      });
      let offsetDateTimeFin = moment().set({
        hour: parseInt(hourEnd),
        minute: parseInt(minuteEnd),
        seconds: 0,
      });
      let data = {
        idsEnfants: listIds,
        offsetDateTime: moment(offsetDateTime).format(),
        offsetDateTimeFin: moment(offsetDateTimeFin).format(),
      };
      this.props.postSiesteMulti(localStorage.getItem("token"), data);
    } else if (
      !this.props.isUpdate &&
      notEmpty(this.props.kidItem) &&
      notEmpty(this.state.siesteFrom) &&
      notEmpty(this.state.siesteTo)
    ) {
      let { siesteFrom, siesteTo } = this.state;
      let [hourStart, minuteStart] = siesteFrom.split("h");
      let [hourEnd, minuteEnd] = siesteTo.split("h");
      let offsetDateTime = moment().set({
        hour: parseInt(hourStart),
        minute: parseInt(minuteStart),
        seconds: 0,
      });
      let offsetDateTimeFin = moment().set({
        hour: parseInt(hourEnd),
        minute: parseInt(minuteEnd),
        seconds: 0,
      });
      let data = {
        offsetDateTime: moment(offsetDateTime).format(),
        offsetDateTimeFin: moment(offsetDateTimeFin).format(),
      };
      this.props.postSiesteSimple(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        data
      );
    }
    this.props.handleSubmit();
  }
  handleEventDelete(e) {
    e.preventDefault();
    this.props.deleteSiesteEvent(
      localStorage.getItem("token"),
      this.props.idEvent,
      this.props.kidItem.id
    );
  }
  handleStyle() {
    return this.props.readySubmit &&
      notEmpty(this.state.siesteFrom) &&
      notEmpty(this.state.siesteTo)
      ? { opacity: 1 }
      : { opacity: 0.25, pointerEvents: "none" };
  }

  render() {
    const { kidItem, t } = this.props;
    return (
      <div className="tab-pane  show active">
        <div className="content">
          <form className="creneau-sieste">
            <div className="row d-flex align-items-center justify-content-center">
              <div className="col-md-4">
                <div className="container-select">
                  <span>{t('modal_enfant.sieste_tab.from')}</span>
                  <select
                    disabled={this.props.onlyView}
                    className="custom-select box-shadow"
                    value={this.state.siesteFrom}
                    id="siesteFrom"
                    onChange={this.handleChange}
                  >
                    {notEmpty(this.state.startArray)
                      ? this.state.startArray.map((element, index) => (
                          <option key={index} value={element}>
                            {element}
                          </option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>
              <div className="col-md-4">
                <div className="container-select">
                  <span>{t('modal_enfant.sieste_tab.to')}</span>
                  <select
                    disabled={this.props.onlyView}
                    className="custom-select box-shadow"
                    value={this.state.siesteTo}
                    id="siesteTo"
                    onChange={this.handleChange}
                  >
                    {notEmpty(this.state.endArray)
                      ? this.state.endArray.map((element, index) => (
                          <option key={index} value={element}>
                            {element}
                          </option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center mt-4 creneau-total">
              {notEmpty(this.state.duration) &&
              notEmpty(this.state.siesteFrom) &&
              notEmpty(this.state.siesteTo) ? (
                <>
                  <IconClock className="img-fluid" />{" "}
                  <p>
                    <strong>{this.state.duration}</strong> {t('modal_enfant.sieste_tab.nap_duration')}
                  </p>
                </>
              ) : (
                ""
              )}
            </div>
          </form>
        </div>
        <div className="d-flex justify-content-center">
          {this.props.onlyView ? (
            ""
          ) : (
            <button
              type="submit"
              onClick={this.handleSubmit}
              className="btn-gradient btn-valid"
              style={this.state.opacity}
            >
              <IconCheckWhite className="img-fluid" />
              {t('common.validate')}
            </button>
          )}
          {this.props.isUpdate ? (
            <button onClick={this.handleEventDelete} className="btn-supprimer">
              {t('common.delete')}
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  postSiesteMulti,
  postSiesteSimple,
  updateSiesteEvent,
  deleteSiesteEvent,
};
const mapStateToProps = ({ modals }) => ({ modals });

const withStore = connect(mapStateToProps, mapDispatchToProps);

export default withStore(withTranslation()(Sieste));
